import React, { useState } from 'react';
import { useMDCockpit } from '../../hooks/useMDCockpit';
import { epochToDisplay } from '../../lib/datetime';
import styles from './TopBar.module.scss';
import { AntarisLogoFull, ClockCogIcon, ModelConfigIcon } from '../Common/components/svgs';
import useNavigation from '../../hooks/useNavigation';

const TopBar: React.FC = () => {
  const goBack = useNavigation().goBack;
  const { openModelConfig, modelData, modelConfigOpen } = useMDCockpit();
  const [showModelInfo, setShowModelInfo] = useState(false);

  const modelInfoContent = (() => {
    const prop = modelData?.propagation as any;
    const name = modelData?.name ?? 'MODEL';
    if (!prop?.startEpoch || !prop?.endEpoch) {
      return { name, startTime: 'Not configured', endTime: 'Not configured' };
    }
    const start = epochToDisplay(prop.startEpoch) ?? '';
    const end = epochToDisplay(prop.endEpoch) ?? '';
    return { name, startTime: start, endTime: end };
  })();

  return (
    <div className={styles.bar}>
      <div
        className={styles.logoContainer}
        onClick={() => goBack()}
        title="Go back to missions"
      >
        <AntarisLogoFull />
      </div>

      <div
        className={styles.modelConfigContainer}
        onMouseEnter={() => setShowModelInfo(true)}
        onMouseLeave={() => setShowModelInfo(false)}
        onClick={openModelConfig}
      >
        <div className={styles.modelLeft}>
          <ModelConfigIcon />
          <span className={styles.modelName}>{modelData?.name ?? 'MODEL'}</span>
        </div>

        <button
          className={`${styles.timerButton} ${modelConfigOpen ? styles.active : ''}`}
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            openModelConfig();
          }}
          title="Configure propagation model"
        >
          <ClockCogIcon />
        </button>

        {showModelInfo && (
          <div className={styles.hoverCard}>
            <strong>{modelInfoContent.name}</strong>
            <span>Start - {modelInfoContent.startTime}</span>
            <span>End - {modelInfoContent.endTime}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TopBar;
